<template>
  <div class="w-root">
    <div class="w-views">
      <ProfileModerateReveals></ProfileModerateReveals>
    </div><!--w-views-->
  </div><!--w-root-->
</template>

<style>

</style>

<script>

import ProfileModerateReveals from "../../widgets/reveal/ProfileModerateReveals.vue";

export default {
  data () {
    return {
    }
  },
  mixins: [
    require('@general/lib/mixin').default
  ],
  components: {
    ProfileModerateReveals
  },
  computed:{
  },
  methods: {

  },
  mounted(){
  },
}
</script>

